import $ from 'jquery'
/* global google */
import richMarker from 'googlemaps-rich-marker-web'
/*
 *  This function will render a Google Map onto the selected jQuery element
 */

const { RichMarker } = richMarker
let map
let googleMarkers = []

function render_map($el) {
  // var
  var $markers = $el.find('.marker')
  const modalId = $el.closest('.acf-map').data('modal-id')
  var styles = [
    {
      featureType: 'all',
      elementType: 'labels.text.fill',
      stylers: [
        {
          saturation: 36,
        },
        {
          color: '#333333',
        },
        {
          lightness: 40,
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.text.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ffffff',
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#fefefe',
        },
        {
          lightness: 20,
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#fefefe',
        },
        {
          lightness: 17,
        },
        {
          weight: 1.2,
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [
        {
          lightness: 20,
        },
        {
          color: '#ececec',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#f0f0ef',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#f0f0ef',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#d4d4d4',
        },
      ],
    },
    {
      featureType: 'landscape.natural',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ececec',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [
        {
          lightness: 21,
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#d4d4d4',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#303030',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          saturation: '-100',
        },
      ],
    },
    {
      featureType: 'poi.attraction',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.business',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.government',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.medical',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'all',
      stylers: [
        {
          visibility: 'false',
        },
      ],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#dedede',
        },
        {
          lightness: 21,
        },
      ],
    },
    {
      featureType: 'poi.place_of_worship',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi.school',
      elementType: 'geometry.stroke',
      stylers: [
        {
          lightness: '-61',
        },
        {
          gamma: '0.00',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi.sports_complex',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 17,
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 29,
        },
        {
          weight: 0.2,
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 18,
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [
        {
          color: '#ffffff',
        },
        {
          lightness: 16,
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [
        {
          color: '#f2f2f2',
        },
        {
          lightness: 19,
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [
        {
          color: '#d9dbda',
        },
        {
          lightness: 17,
        },
      ],
    },
  ] // Uncomment for map styling

  // vars
  var args = {
    zoom: 16,
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    scrollwheel: false,
    styles: styles, // Uncomment for map styling
  }

  // create map
  map = new google.maps.Map($el[0], args)

  map.modalId = modalId
  // add a markers reference
  map.markers = []

  // add markers
  $markers.each(function () {
    add_marker($(this), map)
  })

  // center map
  center_map(map)
}

/*
 *  This function will add a marker to the selected Google Map
 */
var infowindow
function add_marker($marker, map) {
  // var
  var latlng = new google.maps.LatLng(
    $marker.attr('data-lat'),
    $marker.attr('data-lng')
  )

  const locAmount = parseInt($marker.attr('data-loc-amount'))
  const locations = JSON.parse($marker.attr('data-locations'))

  let markerContent
  if (locAmount > 1) {
    markerContent =
      '<div class="map-label"><div class="map-label__content">' +
      locAmount +
      '</div></div>'
  } else {
    markerContent = '<div class="map-label"></div>'
  }
  // create marker
  // var marker = new google.maps.Marker({
  //   position: latlng,
  //   map: map,
  //   title: '3',
  //   //icon: $marker.data('marker-icon') //uncomment if you use custom marker
  // })

  var marker = new RichMarker({
    map: map,
    shadow: 'none',
    position: latlng,
    content: markerContent,
  })

  marker.locations = locations

  // add to array
  map.markers.push(marker)

  // if marker contains HTML, add it to an infoWindow
  if ($.trim($marker.html())) {
    // create info window
    infowindow = new google.maps.InfoWindow()
    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function () {
      // Close previously opened infowindow, fill with new content and open it
      infowindow.close()
      infowindow.setContent($marker.html())
      infowindow.open(map, marker)
    })
  }

  googleMarkers.push(marker)

  google.maps.event.addListener(marker, 'click', function () {
    const $infosContainer = $(map.modalId).find('.js-map-location-infos')
    $infosContainer.html('')
    marker.locations.forEach(function (el) {
      if (el.isVisible) {
        $infosContainer.append(el.infowindowHtml)
      }
    })

    $(map.modalId).addClass('map-modal-show')
    // $(map.modalId).modal('show')
    // $('.modal-backdrop').hide()
    //
    // $('body')
    //   .removeClass('modal-open')
    //   .css('padding-right', '')

    document.addEventListener('click', closeMapModalOnClickOutside, {
      capture: true,
    })
    document.addEventListener('touchstart', closeMapModalOnClickOutside, {
      capture: true,
    })
  })
}

/*
 *  This function will center the map, showing all markers attached to this map
 */

function center_map(map) {
  // vars
  var bounds = new google.maps.LatLngBounds()

  // loop through all markers and create bounds
  $.each(map.markers, function (i, marker) {
    if (marker.visible) {
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      )

      bounds.extend(latlng)
    }
  })

  map.fitBounds(bounds)
  var listener = google.maps.event.addListener(map, 'idle', function () {
    let mapZoom = map.getZoom()
    if (mapZoom > 13) {
      mapZoom = 13
    } else if (mapZoom > 4) {
      mapZoom = mapZoom - 1
    }
    map.setZoom(mapZoom)
    google.maps.event.removeListener(listener)
  })
}

function filterMap(value, zipValue) {
  let foundMarkers = []
  googleMarkers.forEach(function (el) {
    let locationsCount = 0
    let isVisibleMarker = false
    el.locations.forEach(function (location) {
      let isVisibleLocation = false
      if (
        (!zipValue || location.zipCodes.includes(zipValue)) &&
        (!value || location.typeId == value)
      ) {
        isVisibleLocation = true
        isVisibleMarker = true
        locationsCount++
      }
      location.isVisible = isVisibleLocation
    })

    if (locationsCount > 1) {
      el.setContent(
        '<div class="map-label"><div class="map-label__content">' +
          locationsCount +
          '</div></div>'
      )
    } else {
      el.setContent('<div class="map-label"></div>')
    }

    el.setVisible(isVisibleMarker)

    if (isVisibleMarker) {
      foundMarkers.push(el)
    }
  })

  if (foundMarkers.length) {
    center_map(map)
    $('.js-zip-error-message').slideUp()

    if (foundMarkers.length == 1) {
      new google.maps.event.trigger(foundMarkers[0], 'click')
    }
  } else {
    $('.js-zip-error-message').slideDown()
  }
}

// function getNearestLocation(marker) {
//   let map = marker.map
//   let lat = marker.getPosition().lat()
//   let lng = marker.getPosition().lng()
//   let R = 6371 // radius of earth in km
//   let distances = []
//   let closest = -1
//
//   for (let i = 0; i < map.markers.length; i++) {
//     if (!isTriggered && map.markers[i].id !== marker.id) {
//       map.markers[i].order = false
//     }
//
//     if (map.markers[i].order) {
//       if (map.markers[i].order > currentMarker) {
//         map.markers[i].order = false
//       }
//
//       if (map.markers[i].order == currentMarker - 1) {
//         prevMarker = map.markers[i]
//       }
//     }
//
//     let mlat = map.markers[i].position.lat()
//     let mlng = map.markers[i].position.lng()
//     let dLat = rad(mlat - lat)
//     let dLong = rad(mlng - lng)
//     let a =
//       Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//       Math.cos(rad(lat)) *
//         Math.cos(rad(lat)) *
//         Math.sin(dLong / 2) *
//         Math.sin(dLong / 2)
//     let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
//     let d = R * c
//     distances[i] = d
//     if (
//       (closest == -1 || d < distances[closest]) &&
//       marker.id != map.markers[i].id &&
//       !map.markers[i].order
//     ) {
//       closest = i
//     }
//   }
// }

// function getLatLngByZipcode(zipcode) {
//   var latitude
//   var longitude
//   var geocoder = new google.maps.Geocoder()
//   var address = zipcode
//   geocoder.geocode({ address: 'zipcode ' + address }, function(
//     results,
//     status
//   ) {
//     if (status == google.maps.GeocoderStatus.OK) {
//       latitude = results[0].geometry.location.lat()
//       longitude = results[0].geometry.location.lng()
//       alert('Latitude: ' + latitude + '\nLongitude: ' + longitude)
//     } else {
//       alert('Request failed.')
//     }
//   })
//   return [latitude, longitude]
// }

function closeMapModalOnClickOutside(e) {
  const mapModal = document.querySelector(map.modalId)

  if (mapModal) {
    const isClosest = e.target.closest(map.modalId + ' .modal-content')

    if (!isClosest && mapModal.classList.contains('map-modal-show')) {
      mapModal.classList.remove('map-modal-show')
      document.removeEventListener('click', closeMapModalOnClickOutside, {
        capture: true,
      })
      document.removeEventListener('touchstart', closeMapModalOnClickOutside, {
        capture: true,
      })
    }
  }
}

/*
 *  This function will render each map when the document is ready (page has loaded)
 */
$(document).ready(function () {
  $('.js-zip-form').on('submit', function (e) {
    e.preventDefault()
    let zipValue = $(this).closest('.dhsv_vc_map').find('.js-code').val()
    let value = $(this).closest('.dhsv_vc_map').find('.js-map-filter').val()

    filterMap(value, zipValue)
  })

  if ($('.dhsv_vc_map .acf-map').length) {
    $('.dhsv_vc_map .acf-map').each(function () {
      render_map($(this))

      $('.js-map-filter').on('change', function () {
        let value = $(this).val()
        let zipValue = $(this).closest('.dhsv_vc_map').find('.js-code').val()

        filterMap(value, zipValue)
      })
    })
  }

  $('.map-modal-close').on('tap click', function () {
    $(map.modalId).removeClass('map-modal-show')
    document.removeEventListener('click', closeMapModalOnClickOutside, {
      capture: true,
    })
    document.removeEventListener('touchstart', closeMapModalOnClickOutside, {
      capture: true,
    })
  })
})
